// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-links {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 4vw !important;
  height: fit-content;
}

.custom-list-item {
  display: flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  gap: 0.2vw;
  cursor: pointer;
}

.custom-list-item .MuiListItemIcon-root {
  min-width: auto;
  color: inherit;
}

.sidebar-icon-name {
  font-size: 0.75vw;
  font-family: "Poppins";
  font-weight: 500;
  line-height: 1vw;
  color: #444444;
}

.sidebar-icon-name-active {
  color: #fff;
}

.custom-list-item .MuiListItemText-root {
  margin-top: .5vw;
}

.report-nav-icon {
  display: flex;
  opacity: 0.45;
}

.report-nav-icon-active {
  opacity: 1;
}

.sidebar-custom-link {
  text-decoration: none;
  color: inherit;
  /* border:"2px solid white" !important; */
  &:focus {
    outline: none !important;
    border: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/header/Navbar/navbar.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yCAAyC;EACzC;IACE,wBAAwB;IACxB,uBAAuB;EACzB;AACF","sourcesContent":[".nav-links {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 4vw !important;\n  height: fit-content;\n}\n\n.custom-list-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: inherit;\n  gap: 0.2vw;\n  cursor: pointer;\n}\n\n.custom-list-item .MuiListItemIcon-root {\n  min-width: auto;\n  color: inherit;\n}\n\n.sidebar-icon-name {\n  font-size: 0.75vw;\n  font-family: \"Poppins\";\n  font-weight: 500;\n  line-height: 1vw;\n  color: #444444;\n}\n\n.sidebar-icon-name-active {\n  color: #fff;\n}\n\n.custom-list-item .MuiListItemText-root {\n  margin-top: .5vw;\n}\n\n.report-nav-icon {\n  display: flex;\n  opacity: 0.45;\n}\n\n.report-nav-icon-active {\n  opacity: 1;\n}\n\n.sidebar-custom-link {\n  text-decoration: none;\n  color: inherit;\n  /* border:\"2px solid white\" !important; */\n  &:focus {\n    outline: none !important;\n    border: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
